import React from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import EntityPermissionsToggles from "../EntityPermissions";
import FieldToggle from "../../FieldToggle";
import style from "./style";

export default class FacilityPermissionsToggles extends React.Component {
  handleChange({name, value}) {
    const path = ["permissions", ...name.split(".")];
    this.setState({
      touched: true,
      permission: this.state.permission.setIn(path, value)
    });
  }

  getAllChecked(facility) {
    const {entityArray} = this.props;
    return facility.buildings.every(building => entityArray.find(_id => _id === building._id));
  }

  render() {
    const {options, entityArray, disabled, onChange, toggleAll, toggleFacility} = this.props;

    return (
      <div className={this.props.className} style={this.props.style}>
        <div style={{marginBottom: "10px"}}>
          <h3 style={{display: "inline-block"}}>Facilities</h3>
          <FieldToggle
            name="resources.buildings"
            value={entityArray.length > 0 && entityArray.length === options.buildings.length}
            onChange={({name, value}) => {
              toggleAll({
                name,
                value: {
                  toggle: value,
                  value: options.buildings.map(type => type._id)
                }
              });
            }}
            style={style.toggleAllSwitch}
            label="Toggle All"
            toggled={entityArray.length === options.buildings.length}
            disabled={disabled}
          />
        </div>
        <Divider />
        <div style={{marginTop: "10px"}}>
          {options.facilities.map(facility => {
            const allChecked = this.getAllChecked(facility);
            return (
              <EntityPermissionsToggles
                key={"facility_" + facility._id + "_toggles"}
                entityArray={entityArray}
                options={facility.buildings}
                entityName="resources.buildings"
                onChange={onChange}
                toggleName={facility.name}
                toggleState={allChecked}
                toggleAll={() => {
                  toggleFacility(facility, allChecked);
                }}
                disabled={disabled}
                divider={false}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
/*
 */

FacilityPermissionsToggles.propTypes = {
  options: PropTypes.object,
  entityArray: PropTypes.array,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  toggleAll: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/PermissionsToggles/FacilityPermissions/index.jsx